import { styled } from "../../styles";

export const InfiniteTableContainer = styled("div", {
  width: "100%",
  height: "100%",
  backgroundColor: "$white",
  boxSizing: "border-box",
  borderRadius: "8px",
  overflowY: "overlay",

  // Scrollbar styling (matching Table component)
  "&::-webkit-scrollbar": {
    width: "$4",
    height: "$4",
  },

  "&::-webkit-scrollbar-track": {
    marginTop: "80px",
  },

  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "$gray-50",
    borderRadius: "10px",
  },

  // Remove Table's internal scrolling and border
  "& > div:first-child": {
    height: "auto",
    maxHeight: "none",
    overflow: "visible",
    border: "none",
    borderRadius: 0,
  },

  // Hide the tfoot spacing
  "& tfoot": {
    display: "none",
  },

  variants: {
    hasBorder: {
      true: {
        border: "1px solid #ECECEC",
      },
    },
  },
});

export const LoadingMoreContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "12px 0",
  backgroundColor: "$white",
});

export const LoadMoreButton = styled("button", {
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: 500,
  color: "#7562A8",
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  padding: "4px 16px",
  borderRadius: "4px",
  transition: "background-color 0.2s ease",

  "&:hover": {
    backgroundColor: "rgba(117, 98, 168, 0.1)",
  },

  "&:active": {
    backgroundColor: "rgba(117, 98, 168, 0.2)",
  },
});

export const EndOfListMessage = styled("span", {
  fontFamily: "$openSans",
  fontSize: "$text-sm",
  color: "$gray-60",
  fontWeight: 400,
});
